// reusable selectors for auth Slices
import { useSelector } from "react-redux";
import { AuthUser } from "redux/reducers/authSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

export const useAuthSelectors = () => {
  const selectAuthUser = useSelector<RootSliceType, AuthUser["authUser"]>(
    (state) => state.auth.authUser
  );
  const selectVerifyEmail = useSelector<RootSliceType, AuthUser["verifyEmail"]>(
    (state) => state.auth.verifyEmail
  );
  const selectResetPassword = useSelector<
    RootSliceType,
    AuthUser["resetPassword"]
  >((state) => state.auth.resetPassword);
  return {
    selectAuthUser,
    selectVerifyEmail,
    selectResetPassword,
  };
};
